const RESPONSE_TYPES = [
  {
    value: 'ok',
    label: 'Return OK',
  },
  {
    value: 'error',
    label: 'Return Error',
  },
  {
    value: 'timeout',
    label: 'Timeout',
  },
  {
    value: '500',
    label: '5xx Error',
  },
];

const DECISION_RESPONSE_VALUES = [
  {
    id: 0,
    label: 'Return Approved',
    value: 'sendApproved',
  },
  {
    id: 1,
    label: 'Return Conditional Approval',
    value: 'sendReview',
  },
  {
    id: 2,
    label: 'Return Rejected',
    value: 'sendRejected',
  },
  {
    id: 3,
    label: 'Return Technical Error',
    value: 'sendTechnicalError',
  },

];

const OTP_VALIDATE_VALUES = [
  {
    id: 0,
    label: 'Return success',
    value: 'sendSuccess',
  },
  {
    id: 1,
    label: 'Return failure',
    value: 'sendFailure',
  },
];

const CREDIT_APPROVED_VALUES = [
  {
    id: 0,
    label: 'Return approved',
    value: 'ELIGIBLE',
  },
  {
    id: 1,
    label: 'Return rejected',
    value: 'Rejected',
  },
];

export {
  RESPONSE_TYPES,
  DECISION_RESPONSE_VALUES,
  OTP_VALIDATE_VALUES,
  CREDIT_APPROVED_VALUES,
};
